import React, { useEffect } from "react";

export default function Callback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state"); // <--- NEU!
    if (code && state) {
      // Code und State an dein Backend schicken:
      fetch("https://www.denisbitter.de/stage01/api/linkedin/callback.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, state }) // <--- NEU!
      })
        .then(res => res.json())
        .then(data => {
          if (data.access_token) {
            alert("Access Token erhalten!");
            // Hier kannst du ggf. window.close() oder redirect machen.
          } else {
            alert("Fehler: " + JSON.stringify(data));
          }
        });
    } else {
      alert("Kein Code oder State empfangen!");
    }
  }, []);

  return <h2 className="text-center font-mono text-sm">Authentifizierung läuft…</h2>;
}
